












import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Mprotocol extends Vue {
  handleJumpPage(url: string): void {
    ;(window as any).MgtvApi.jumpPage({
      url,
    })
  }
}
